import { render, staticRenderFns } from "./BtnDefault.vue?vue&type=template&id=13da0a4f&scoped=true&"
import script from "./BtnDefault.vue?vue&type=script&lang=ts&"
export * from "./BtnDefault.vue?vue&type=script&lang=ts&"
import style0 from "./BtnDefault.vue?vue&type=style&index=0&id=13da0a4f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13da0a4f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VIcon,VProgressCircular})
